// Marka para birimi → sembol. Boş/TRY ise ₺ (mevcut markaların varsayılanı).
const SYMBOLS = { TRY: '₺', USD: '$', EUR: '€', GBP: '£', CAD: 'CA$', AUD: 'A$', JPY: '¥', CHF: 'CHF ', SEK: 'kr ', NOK: 'kr ', DKK: 'kr ', PLN: 'zł ', AED: 'AED ', SAR: 'SAR ' };

export function currencySymbol(code) {
  const c = String(code || '').trim().toUpperCase();
  if (!c) return '₺';
  return SYMBOLS[c] || `${c} `;
}
